import { Box, Button, Link, Paper, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { COMING_SOON_CONTENT } from './comingSoonContent';
import { useAuth } from '../../core/authContext';
import { feedbackSurveyUrl } from '../../core/surveyLink';

const { eyebrow, title, body, contactEmail, surveyLabel, buttonLabel, dashboardPath } =
  COMING_SOON_CONTENT;

export function ComingSoon() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const surveyUrl = feedbackSurveyUrl(user?.id);
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 3, md: 4 },
        width: '100%',
        maxWidth: 480,
        borderRadius: 2,
        border: '1px solid #E4E4EC',
        boxShadow: '0 1px 2px rgba(16, 24, 40, 0.04)',
      }}
    >
      <Stack spacing={2}>
        <Box>
          <Typography sx={{ fontSize: 14, fontWeight: 700, color: '#5B5B73', mb: 0.5 }}>
            {eyebrow}
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 700, color: '#0F1024' }}>
            {title}
          </Typography>
        </Box>

        <Typography sx={{ color: '#5B5B73', fontSize: 15, lineHeight: 1.6 }}>
          {body}{' '}
          <Link href={`mailto:${contactEmail}`} sx={{ color: '#1F1F70', fontWeight: 600 }}>
            {contactEmail}
          </Link>{' '}
          or{' '}
          <Link
            href={surveyUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: '#1F1F70', fontWeight: 600 }}
          >
            {surveyLabel}
          </Link>
          .
        </Typography>

        <Box>
          <Button
            variant="contained"
            onClick={() => navigate(dashboardPath)}
            sx={{
              bgcolor: '#1F1F70',
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              py: 1.25,
              borderRadius: 1.5,
              '&:hover': { bgcolor: '#18185A' },
            }}
          >
            {buttonLabel}
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
}
